
import { useTranslation } from 'react-i18next';

export default function FeaturesSection() {
  const { t } = useTranslation();

  const features = [
    { icon: 'ri-magic-line', titleKey: 'features.f1.title', descKey: 'features.f1.desc', color: 'from-primary to-emerald-400' },
    { icon: 'ri-image-edit-line', titleKey: 'features.f2.title', descKey: 'features.f2.desc', color: 'from-accent to-orange-400' },
    { icon: 'ri-palette-line', titleKey: 'features.f3.title', descKey: 'features.f3.desc', color: 'from-gray-700 to-gray-500' },
    { icon: 'ri-flashlight-line', titleKey: 'features.f4.title', descKey: 'features.f4.desc', color: 'from-yellow-500 to-amber-500' },
    { icon: 'ri-shield-check-line', titleKey: 'features.f5.title', descKey: 'features.f5.desc', color: 'from-primary to-teal-500' },
    { icon: 'ri-infinity-line', titleKey: 'features.f6.title', descKey: 'features.f6.desc', color: 'from-accent to-red-500' },
  ];

  return (
    <section id="features" className="py-24 lg:py-40 bg-[#1e2025]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <span className="inline-block px-5 py-2.5 bg-[#252830] text-gray-300 rounded-full text-base font-bold mb-5 border border-gray-700">
            {t('features.badge')}
          </span>
          <h2 className="text-5xl lg:text-6xl font-display font-black text-white mb-8">
            {t('features.title')}
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto font-semibold">
            {t('features.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative bg-[#252830] rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-800 hover:border-primary/30 hover:-translate-y-2"
            >
              <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${feature.color} flex items-center justify-center mb-7 group-hover:scale-110 transition-transform`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-black text-white mb-4 group-hover:text-primary transition-colors">
                {t(feature.titleKey)}
              </h3>
              <p className="text-gray-400 leading-relaxed text-base font-medium">
                {t(feature.descKey)}
              </p>
              <div className={`absolute inset-0 rounded-2xl bg-gradient-to-br ${feature.color} opacity-0 group-hover:opacity-5 transition-opacity`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
